import sipe from "assets/img/payment-clients/sipe.png";
import pixLotus from "assets/img/payment-clients/pix.png";
import pix from "assets/img/payment-clients/pix.png";
import blumon from "assets/img/payment-clients/blumon.png";
import stripe from "assets/img/payment-clients/stripe.png";
import memphis from "assets/img/payment-clients/memphis.png";
import repyd from "assets/img/payment-clients/rapyd.png";
import mit from "assets/img/payment-clients/mit.png";
import reSet from "assets/img/payment-clients/reset.png";
import banwire from "assets/img/payment-clients/banwire.jpg";
import valitor from "assets/img/payment-clients/valitor.png";
import bambora from "assets/img/payment-clients/bambora.png";
import Scipiopay from "assets/img/payment-clients/Scipiopay.png";
import Betapay from "assets/img/payment-clients/Betapay.png";
import Aurea_via from "assets/img/payment-clients/Aurea_via.png";
import Kasha from "assets/img/payment-clients/Kasha.jpg";
import Platy from 'assets/img/payment-clients/Platy.png'
import MasterPay from 'assets/img/payment-clients/master_Pay.png'
import Neonpay from 'assets/img/payment-clients/neonpay.png'
import Bm2Pay from 'assets/img/payment-clients/bm2pay.svg'
import Threexpay from "assets/img/payment-clients/3XPAY.png";
import Digitarium from "assets/img/payment-clients/digitarium.png";
import Moneto from "assets/img/payment-clients/moneto.png";
import Tangoindia from "assets/img/payment-clients/tangoindia.png";
import G2pay from "assets/img/payment-clients/g2pay.png";
import AlphaPays from "assets/img/payment-clients/alphapays.svg";
import Clickopay from "assets/img/payment-clients/clickopay.svg";
import CFGPayments from "assets/img/payment-clients/cfg.png";
import Ragapay from "assets/img/payment-clients/ragapay.png";
import Capa from "assets/img/payment-clients/capa.svg";
import Orionx from "assets/img/payment-clients/orionx.svg";
import Mauricio from "assets/img/payment-clients/placeholder.png";
import Blox from "assets/img/payment-clients/blox.svg";
import Terracall from "assets/img/payment-clients/Terracall.png";
import MyXspend from "assets/img/payment-clients/myxspend.svg";
import Bennupay from "assets/img/payment-clients/bennupay.png";
import Xorapay from "assets/img/payment-clients/Xorapay.png";
import TestGateway from "assets/img/payment-clients/testgateway.png";
import Murkon from "assets/img/payment-clients/Murkon.png";
import Changelly from "assets/img/payment-clients/Changelly.png";
import Transvoucher from "assets/img/payment-clients/Transvoucher.png";
import DNSPay from "assets/img/payment-clients/dnspay.png";
import Gate2Way from "assets/img/payment-clients/Gate2Way.png";
import Payin from "assets/img/payment-clients/payin.png";
import PayoutsTech from "assets/img/payment-clients/PayoutsTech.png";
import Supefina from "assets/img/payment-clients/supefina.svg";
import DirectPayment from "assets/img/payment-clients/DirectPayment.png";
import JDPay from "assets/img/payment-clients/JDPay.png";
import Portinax from "assets/img/payment-clients/Portinax.png";

export function getImage(name: string) {
  if (name === 'Sipe') {
    return sipe;
  } else if (name === 'Supefina') {
    return Supefina;
  } else if (name === 'Pix-Lotus') {
    return pixLotus;
  } else if (name === 'DirectPayment') {
    return DirectPayment;
  } else if (name === 'JDPay') {
    return JDPay;
  } else if (name === 'Portinax') {
    return Portinax;
  } else if (name === "3xpay") {
    return Threexpay;
  } else if (name === 'Bm2pay') {
    return Bm2Pay;
  } else if (name === 'Digitarium') {
    return Digitarium;
  } else if (name === 'Tangoindia') {
    return Tangoindia;
  } else if (name === 'G2Pay') {
    return G2pay;
  } else if (name === 'AlphaPays') {
    return AlphaPays;
  } else if (name === 'Clickopay') {
    return Clickopay;
  } else if (name === 'CFGPayments') {
    return CFGPayments;
  } else if (name === 'Ragapay') {
    return Ragapay;
  } else if (name === 'Capa') {
    return Capa;
  } else if (name === 'Orionx') {
    return Orionx;
  } else if (name === 'Mauricio') {
    return Mauricio;
  } else if (name === 'Blox') {
    return Blox;
  } else if (name === 'Terracall') {
    return Terracall;
  } else if (name === 'MyXspend') {
    return MyXspend;
  } else if (name === 'Bennupay') {
    return Bennupay;
  } else if (name === 'Xorapay') {
    return Xorapay;
  } else if (name === 'Murkon') {
    return Murkon;
  } else if (name === 'Changelly Fiat') {
    return Changelly;
  } else if (name === 'Gate2Way') {
    return Gate2Way;
  } else if (name === 'Payin') {
    return Payin;
  } else if (name === 'Payouts Tech') {
    return PayoutsTech;
  } else if (name === 'Changelly Crypto') {
    return Changelly;
  } else if (name === 'Transvoucher') {
    return Transvoucher;
  } else if (name === 'DNSPay') {
    return DNSPay;
  } else if (name === 'TestGateway') {
    return TestGateway;
  } else if (name === 'Moneto') {
    return Moneto;
  } else if (name === 'Pix') {
    return pix;
  } else if (name === 'Blumon') {
    return blumon;
  } else if (name === 'Stripe') {
    return stripe;
  } else if (name === 'Memphis') {
    return memphis;
  } else if (name === 'Raypd') {
    return repyd;
  } else if (name === 'Banwire') {
    return banwire;
  } else if (name === 'Valitor') {
    return valitor;
  } else if (name === 'MIT') {
    return mit;
  } else if (name === 'Re-set') {
    return reSet;
  } else if (name === 'Bambora') {
    return bambora;
  }
  else if (name === 'Scipiopay') {
    return Scipiopay;
  }
  else if (name === 'Aurea Via') {
    return Aurea_via;
  }
  else if (name === 'Betapay') {
    return Betapay;
  } else if (name === 'Kasha') {
    return Kasha;
  } else if (name === "Platy") {
    return Platy
  } else if (name === "Platy 2DS") {
    return Platy
  } else if (name === "Platy 3DS") {
    return Platy
  } else if (name === "Masterpay") {
    return MasterPay
  }
else if (name === "Neonpay") {
  return Neonpay
}
}